module.exports = __webpack_public_path__ + "static/sensors-b0d0a6ee6c52715f65bb6c44c76a7ee3.png";